/**
 * The upstream description generator sometimes writes a missing value as the
 * word "null" ("White Ford Ranger ute, null tray"). Drops the comma-separated
 * fragments containing it; `null` when nothing is left.
 */
export function cleanDescription(text: string | null | undefined): string | null {
  if (!text) return null;
  const fragments = text
    .split(",")
    .map((fragment) => fragment.trim())
    .filter((fragment) => fragment !== "" && !/\bnull\b/i.test(fragment));
  return fragments.length === 0 ? null : fragments.join(", ");
}
